export default __webpack_public_path__ + "4d5a3f2732aa74b4a166c9fac7e6f67a.svg";